import { render } from "./SeleccionExpedicionesPage.vue?vue&type=template&id=7bb5dd70&scoped=true"
import script from "./SeleccionExpedicionesPage.vue?vue&type=script&lang=js"
export * from "./SeleccionExpedicionesPage.vue?vue&type=script&lang=js"

import "./SeleccionExpedicionesPage.vue?vue&type=style&index=0&id=7bb5dd70&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb5dd70"]])

export default __exports__